import * as _ from 'underscore';

import BooleanField from '../../../../_common/platform/ts/BooleanField';
import StringField from '../../../../_common/platform/ts/StringField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import { SelectMultiField } from '../../../../_common/application/ts/SelectMultiField';
import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';

import { FontBoxField } from '../../../../_common/platform/ts/FontBoxField';
import { SizeField } from '../../../../_common/platform/ts/SizeField';

import { PaletteListField } from '../../../../_common/platform/ts/PaletteListField';

import { ChartCustomStylesField } from '../components/ChartCustomStylesFieldClass';

import { ChartAxisField_inThemes } from '../components/ChartAxisFieldClass_inThemes';
import { ChartAxisArrayField_inThemes } from '../components/ChartAxisArrayFieldClass_inThemes';
import { ChartBreaksField_inThemes } from '../components/ChartBreaksFieldClass_inThemes';
import { ChartStripsField_inThemes } from '../components/ChartStripsFieldClass_inThemes';
import { ChartConstantLinesField_inThemes } from '../components/ChartConstantLinesFieldClass_inThemes';

import { validators as validatorsColorScales } from '../../../../_common/platform/ts/validatorsColorScales';
import { validators } from '../../../../_common/platform/ts/validators';
import { validators as ChartValidators } from '../validators';

// Theme dispatcher module
import * as appTheme from '../../../../_common/platform/ts/appTheme';

// Any dependency themes, which should be initialized before this one
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';

//LL: MergeSeriesByStack_New
import { themeFields, themeFieldsDefaults, MergeSeriesByStack_New } from './themeFields';

import { themeVars } from '../../../../pdc-platform/src/ts/themes/themeConstants';

import { CHART_CONSTANT_LINES, CHART_STRIPS, chartConstants } from '../../../../pdc-widget-chart/src/ts/chartConstants';

import { DevExprPaletteManager, ColorManager } from '../DashboardWidget_dxChart_Parametrized';
import { ChartPropsManager } from '../ChartPropsManager';

declare var Color: any;

function isWidgetLevel(levels) {
    if (levels == null || levels.length === 0) {
        return false;
    }
    if (levels[0] !== 'widget') {
        return false;
    }
    return true;
}

function isWidgetLevel_Chart(levels, widgetType) {
    if (!isWidgetLevel(levels)) {
        return false;
    }
    if (widgetType !== 'pdc-widget-chart') {
        //LL: for Widget Containers
        return false;
    }
    return true;
}

function isHidden_Always(levels, widgetParams, widgetType) {
    return true;
}

//LL: widgetType  = "pdc-widget-chart"
//LL: use it in ThemeField.tsx  getFields
//  consider level, widgetParams, other Theme fields
function isHidden_forD3(levels, widgetParams, widgetType) {
    if (!isWidgetLevel(levels)) {
        return false;
    }
    if (widgetType !== 'pdc-widget-chart') {
        //LL: for Widget Containers
        return false;
    }
    return ChartPropsManager.getHiddenGroup_for_D3(widgetParams); // hidden if D3
}

//LL: widgetType  = "pdc-widget-chart"
//LL: use it in ThemeField.tsx  getFields
function isHidden_not_D3(levels, widgetParams, widgetType) {
    if (!isWidgetLevel(levels)) {
        return false;
    }
    if (widgetType !== 'pdc-widget-chart') {
        //LL: for Widget Containers
        return false;
    }
    return ChartPropsManager.getHiddenGroup_not_D3(widgetParams); // hidden if not D3
}

//LL: widgetType  = "pdc-widget-chart"
//LL: use it in ThemeField.tsx  getFields
function isHidden_not_Pie(levels, widgetParams, widgetType) {
    // hidden if not Pie
    if (!isWidgetLevel(levels)) {
        return false;
    }
    if (widgetType !== 'pdc-widget-chart') {
        //LL: for Widget Containers
        return false;
    }
    return ChartPropsManager.getHiddenGroup_Pie(widgetParams); // hidden if not Pie
}

//LL: widgetType  = "pdc-widget-chart"
//LL: use it in ThemeField.tsx  getFields
function isHidden_not_XY(levels, widgetParams, widgetType) {
    // hidden if not XY (Pie, D3)
    if (!isWidgetLevel(levels)) {
        return false;
    }
    if (widgetType !== 'pdc-widget-chart') {
        //LL: for Widget Containers
        return false;
    }
    return ChartPropsManager.getHiddenGroup_XY_withoutD3(widgetParams); // hidden if not XY (Pie, D3)
}

//LL: 25.06.25
function isHidden_title_subTitle_useOwnFont(levels, widgetParams, widgetType) {
    let isHidden = isHidden_forD3(levels, widgetParams, widgetType);
    if (isHidden) {
        return true;
    }
    //let a = widgetParams.theme._custom[themeFields.title_subTitle_useOwnFont]; //LL: unfortunately, is set only after config save
    return false;
}

//LL:  my flag  for themeFields.geometryMisc_mergeSeriesByStack => themeFields.coloring_separateColorsToSideBySideStacks
//   MergeSeriesByStack_New:  imported from themeFields
function isHiddenWhen_MergeSeriesByStack_New() {
    return MergeSeriesByStack_New;
}
function isHiddenWhen_MergeSeriesByStack_Old() {
    return !MergeSeriesByStack_New;
}

//    id: themeFields.DevExpress_messages_processing_method
function isHidden_DevExpress_messages_processing_method(levels, widgetParams, widgetType) {
    if (!isWidgetLevel(levels)) {
        return false;
    }
    let a = widgetParams.theme._custom[themeFields.DevExpress_messages_processing_method];
    return false;
    //if (widgetType !== 'pdc-widget-chart') {
    //    //LL: for Widget Containers
    //    return false;
    //}
    //return ChartPropsManager.getHiddenGroup_XY_withoutD3(widgetParams); // hidden if not XY (Pie, D3)
}

// This array, which saves all glob objects, on which theme was initialized
// It's used to make sure that `init` is launched only once for each glob.
// Here, it's possible that platform will run init for widgetTheme more than 1 time.
var _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    // Init parent theme
    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: themeFields.themeSection_Main,
            name: 'Chart',
            parent: 'widget',
            //explanation: 'These options are ',
            //preview: ThemePreview,
            //previewClassName: 'preview-widget preview-widget-gantt',
            themeType: 'Chart',
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Axis,
            name: 'Axis',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            hiddenOptions: { hiddenFunction: isHidden_not_XY },
            dontSortChildren: true,
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Axis_Arguments,
            name: 'Argument Axis',
            parent: themeFields.themeSection_Axis,
            themeType: 'Chart',
            hiddenOptions: { hiddenFunction: isHidden_not_XY },
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Axis_Values,
            name: 'Value Axis',
            parent: themeFields.themeSection_Axis,
            themeType: 'Chart',
            hiddenOptions: { hiddenFunction: isHidden_not_XY },
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Axis_ExtraValues,
            name: 'Extra Value Axes',
            parent: themeFields.themeSection_Axis,
            themeType: 'Chart',
            hiddenOptions: { hiddenFunction: isHidden_not_XY },
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_AxisBreaks,
            name: 'Axis Breaks',
            parent: themeFields.themeSection_Axis,
            themeType: 'Chart',
            hiddenOptions: { hiddenFunction: isHidden_not_XY },
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_AxisConstantLines,
            name: 'Axis Constant Lines',
            parent: themeFields.themeSection_Axis,
            themeType: 'Chart',
            hiddenOptions: { hiddenFunction: isHidden_not_XY },
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_AxisStrips,
            name: 'Axis Strips',
            parent: themeFields.themeSection_Axis,
            themeType: 'Chart',
            hiddenOptions: { hiddenFunction: isHidden_not_XY },
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Coloring,
            name: 'Coloring',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },
        {
            id: themeFields.themeSection_Styling,
            name: 'Styling',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Title,
            name: 'Title',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Geometry,
            name: 'Geometry',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Legend,
            name: 'Legend',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_PointLabels,
            name: 'Point Labels',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Tooltips,
            name: 'Tooltips',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Crosshair,
            name: 'Crosshair',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            hiddenOptions: { hiddenFunction: isHidden_not_XY },
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_ZoomingAndScrolling,
            name: 'Zooming and Scrolling',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            hiddenOptions: { hiddenFunction: isHidden_not_XY },
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Animation,
            name: 'Animation',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_AdaptiveLayout,
            name: 'Adaptive Layout',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        },

        {
            id: themeFields.themeSection_Warnings,
            name: 'Warnings',
            parent: themeFields.themeSection_Main,
            themeType: 'Chart',
            visibility: ['application', 'workspace', 'pdc-widget-chart']
        }
    ]);

    appTheme.registerGroups([
        // - Actual Axis  (in main section)
        {
            id: themeFields.themeGroup_ActualAxis,
            name: 'Actual Axes',
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.themeGroup_ActualAxis_main,
            name: 'Main Axes',
            explanation:
                'Objects in this section are actual for this widget. In sub-section "Axis" see fully inheritable list of predefined Axis objects that can be applied here.',
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.themeGroup_ActualAxis_auxiliary,
            name: 'Auxiliary Axes',
            explanation:
                'Objects in this section are actual for this widget. In sub-section "Axis" see fully inheritable list of predefined Axis objects that can be applied here.',
            section: themeFields.themeSection_Main
        },

        {
            id: themeFields.themeGroup_ActualStrips,
            name: 'Actual Strips',
            explanation:
                'Objects in this section are actual for this widget. In sub-section "Axis Strips" see fully inheritable list of predefined objects that can be applied here.',
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.themeGroup_ActualConstantLines,
            name: 'Actual Constant Lines',
            explanation:
                'Objects in this section are actual for this widget. In sub-section "Axis Constant Lines" see fully inheritable list of predefined objects that can be applied here.',
            section: themeFields.themeSection_Main
        },
        {
            id: themeFields.themeGroup_ActualBreaks,
            name: 'Actual Breaks',
            explanation: 'Objects in this section are actual for this widget.',
            section: themeFields.themeSection_Main
        },

        // - Axis

        {
            id: themeFields.themeGroup_HorizontalAxis,
            name: 'Horizontal Axis',
            explanation:
                'Unless the Rotated option is set to true, the Argument axis is horizontal and the Value axis is vertical..',
            section: themeFields.themeSection_Axis
        },

        {
            id: themeFields.themeGroup_AxisList,
            name: 'Axis List',
            section: themeFields.themeSection_Axis
        },

        //LL: inheritable section, all levels
        {
            id: themeFields.themeGroup_AxisStrips,
            name: 'Axis Strips',
            section: themeFields.themeSection_AxisStrips
        },
        {
            id: themeFields.themeGroup_AxisStripList,
            name: 'Axis Strip List',
            section: themeFields.themeSection_AxisStrips
        },

        //LL: inheritable section, all levels
        {
            id: themeFields.themeGroup_AxisConstantLines,
            name: 'Axis Constant Lines',
            section: themeFields.themeSection_AxisConstantLines
        },
        {
            id: themeFields.themeGroup_AxisConstantLineList,
            name: 'Axis Constant Line List',
            section: themeFields.themeSection_AxisConstantLines
        },

        //LL: inheritable section, all levels
        {
            id: themeFields.themeGroup_AxisBreaks,
            name: 'Axis Breaks',
            section: themeFields.themeSection_AxisBreaks
        },

        // - Coloring and Styling

        {
            id: themeFields.themeGroup_Coloring,
            name: 'Color Assignment', // 'Color Assignment for Chart Elements',
            section: themeFields.themeSection_Coloring
        },
        {
            id: themeFields.themeGroup_Styling,
            name: 'Styling',
            section: themeFields.themeSection_Styling
        },

        // - Title

        {
            id: themeFields.themeGroup_Title_Font,
            name: 'Title Font',
            section: themeFields.themeSection_Title
        },
        {
            id: themeFields.themeGroup_Title_subTitle_Font,
            name: 'SubTitle Font',
            section: themeFields.themeSection_Title
        },
        {
            id: themeFields.themeGroup_Title_Position,
            name: 'Title Position',
            section: themeFields.themeSection_Title
        },

        // - Geometry

        {
            id: themeFields.themeGroup_GeometryMisc,
            name: 'Geometry Miscellaneous',
            section: themeFields.themeSection_Geometry
        },
        {
            id: themeFields.themeGroup_BarOptions,
            name: 'Bar Options',
            section: themeFields.themeSection_Geometry
        },
        {
            id: themeFields.themeGroup_PieOptions,
            name: 'Pie/Doughnut Options',
            section: themeFields.themeSection_Geometry
        },

        // - Crosshair
        {
            id: themeFields.themeGroup_crosshairLabels,
            name: 'Crosshair Labels',
            explanation:
                'Crosshair labels appear on the chart axes when a user pauses on a series point. They display the argument and the value of this series point.',
            section: themeFields.themeSection_Crosshair
        },

        // - Zooming and Scrolling

        {
            id: themeFields.themeGroup_ScrollBar_old,
            name: 'ScrollBar by RangeSelector for Chart data (old)',
            section: themeFields.themeSection_ZoomingAndScrolling
        },
        {
            id: themeFields.themeGroup_ZoomingAndScrolling_new,
            name: 'Zooming and Scrolling (new)',
            section: themeFields.themeSection_ZoomingAndScrolling
        },

        // - Legend
        {
            id: themeFields.themeGroup_Legend_notD3,
            name: 'Except for AreaMap and BubbleMap Charts:',
            section: themeFields.themeSection_Legend
        },
        {
            id: themeFields.themeGroup_Legend_D3,
            name: 'Only for AreaMap and BubbleMap Charts:',
            section: themeFields.themeSection_Legend
        },

        // - Point Labels

        {
            id: themeFields.themeGroup_PointLabels_Color, //LL: only for XY
            name: 'Label Color for XY Charts',
            section: themeFields.themeSection_PointLabels
        },
        {
            id: themeFields.themeGroup_PointLabels_XY,
            name: 'Properties of XY Charts',
            section: themeFields.themeSection_PointLabels
        },
        {
            id: themeFields.themeGroup_PointLabels_Pie,
            name: 'Properties of Pie/Doughnut Charts',
            section: themeFields.themeSection_PointLabels
        },
        {
            id: themeFields.themeGroup_PointLabels_Pie_Color,
            name: 'Label Color for Pie/Doughnut Charts',
            section: themeFields.themeSection_PointLabels
        },
        {
            id: themeFields.themeGroup_PointLabels_D3,
            name: 'Properties of AreaMap and BubbleMap Charts',
            section: themeFields.themeSection_PointLabels
        },
        {
            id: themeFields.themeGroup_PointLabels_ShowInLabel,
            name: 'Show in Labels',
            section: themeFields.themeSection_PointLabels
        },
        {
            id: themeFields.themeGroup_PointLabels_onlyOneLabelPerStack,
            name: 'Single Label per Stack for Stacked Bars',
            explanation: 'Use to show summary "total value" for Numeric axis or common "group"',
            section: themeFields.themeSection_PointLabels
        },
        {
            id: themeFields.themeGroup_PointLabels_SubTitles, //LL: only for XY
            name: 'SubTitles for Side-By-Side Bar Charts',
            section: themeFields.themeSection_PointLabels
        },

        {
            id: themeFields.themeGroup_DevExpress_messages,
            name: 'Handling Warnings and Errors issued by underlying tool (DevExpress)', // Processing
            section: themeFields.themeSection_Warnings
        }
    ]);

    // Register theme variables
    appTheme.registerVars([
        //LL: Sections without inheritance, visibility only for Widget level
        //    id: themeFields.themeSection_withoutInheritance,

        // ------------- themeSection_Coloring   themeGroup_Coloring -------

        //LL: by Leo: I would move ‘Palette’ and ‘Single Color’ outside the Grouping box.

        {
            id: themeFields.coloring_palette,
            param: new PaletteListField(this.glob, 'Palette', [], 'Office', {
                themeFieldName_forCustomPalettes: themeVars.palette_set,
                builtinPalettes: [
                    'Office', //'default',  //LL:  DevExpress 18.1.5
                    'Soft Pastel',
                    'Harmony Light',
                    'Pastel',
                    'Bright',
                    'Soft',
                    'Ocean',
                    'Vintage',
                    'Violet',
                    'Carmine', //LL: DevExpr ver 17.2.5
                    'Dark Moon', //LL: DevExpr ver 17.2.5
                    'Soft Blue', //LL: DevExpr ver 17.2.5
                    'Dark Violet', //LL: DevExpr ver 17.2.5
                    'Green Mist', //LL: DevExpr ver 17.2.5
                    'Material', //LL: DevExpress 18.1.5
                    'Monochrome Blue' //LL: custom by VR
                ]
            }),
            section: themeFields.themeSection_Coloring
        },

        {
            id: themeFields.coloring_singleSeriesColor,
            param: new ColorBoxField(this.glob, 'Single Color', [], DevExprPaletteManager.getDefaultSeriesColor(), {
                hideTransparency: true
            }),
            section: themeFields.themeSection_Coloring
        },

        //LL: Border Color for Bars
        //{
        //    id: 'chart-coloring-border-fictiv',
        //    param: new StringField(
        //        glob,
        //        'Border is applied for Bars and Areas:',
        //        [],
        //        '',
        //        {
        //            hidden: true,
        //            readOnly: true,
        //            inline: true
        //        }
        //    ),
        //    section: themeFields.themeSection_Coloring
        //},
        {
            id: themeFields.coloring_borderVisible,
            hidden: isHidden_not_XY,
            param: new BooleanField(this.glob, 'Border Visible (is applied for Bars and Areas)', [], false),
            section: themeFields.themeSection_Coloring
        },
        {
            id: themeFields.coloring_borderColor,
            hidden: isHidden_not_XY,
            param: new ColorBoxField(this.glob, 'Border Color', [], 'black', { hideTransparency: true }),
            section: themeFields.themeSection_Coloring
        },
        {
            id: themeFields.coloring_borderWidth,
            param: new NumberField(
                this.glob,
                'Border Width',
                [validators.number.positive, validators.number.integer],
                2,
                {
                    min: 1,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Coloring
        },

        {
            id: themeFields.coloring_colorAssignment,
            param: new SelectField(this.glob, 'Color Assignment Method', [], 'default', {
                values: [
                    'default',
                    'UsePalette',
                    'UseSpecifiedColor',
                    'UseEntityColorMapping',
                    'UseColoringByDataQuery'
                ],
                display: [
                    'Automatic (Single Color for single-series, Palette for multi-series and Pie Sectors)',
                    'Use Palette',
                    'Use Single Color (not used for Pie)',
                    'Use Entity Color Mapping',
                    'Use Coloring by Data Query' //"Use Coloring by Data Query (Automatic, if not defined)"
                ]
            }),
            section: themeFields.themeSection_Coloring,
            group: themeFields.themeGroup_Coloring
        },

        //   ----  HIDDEN, NOT USED ---------
        //LL: Leo:  to rem, add "Use Entity Color Mapping"  to drop-down 'Color Assignment'
        {
            id: themeFields.coloring_applyEntityColorMapping,
            hidden: isHidden_Always,
            param: new BooleanField(this.glob, 'Apply Entity Color Mapping', [], true),
            section: themeFields.themeSection_Coloring,
            group: themeFields.themeGroup_Coloring
        },

        //  paletteExtensionMode  DevExpress 18.1.5
        {
            id: themeFields.coloring_paletteExtensionMode,
            param: new SelectField(
                this.glob,
                //'Palette Extension Mode',
                'Palette Extension Mode - method to create new colors in palette when they are not enough',
                [],
                DevExprPaletteManager.paletteExtensionMode_default,
                {
                    values: ['blend', 'alternate', 'extrapolate'],
                    //display: ["blend", "alternate", "extrapolate"],
                    display: [
                        'Blend - blend of two neighboring colors is inserted between these colors',
                        'Alternate - repeat the full set of palette colors, alternating their normal, lightened, and darkened shades',
                        'Extrapolate - repeat the full set of palette colors, changing their shade gradually from dark to light'
                    ],
                    tooltips: [
                        'Create a blend of two neighboring colors and insert it between these colors in the palette',
                        'Repeat the full set of palette colors, alternating their normal, lightened, and darkened shades in that order',
                        'Repeat the full set of palette colors, changing their shade gradually from dark to light'
                    ]
                }
            ),
            group: themeFields.themeGroup_Coloring,
            section: themeFields.themeSection_Coloring
        },

        //   ----  HIDDEN, NOT USED ---------
        //LL: Leo: don't use colorMapPriority, always color by "group", because "stack" is the same
        //                   Just, Drop the option….
        //  colorMapPriority (SBS+Stack)   "entities-model-color-mapping"
        {
            id: themeFields.coloring_colorMapPriority,
            hidden: isHidden_Always,
            param: new SelectField(
                this.glob,
                'Priority to apply Entity Color Mapping (when using combined Stacked + SideBySide grouping)',
                [],
                'SideBySide',
                {
                    values: ['Stacked', 'SideBySide'],
                    display: ['Stacked', 'Side By Side']
                }
            ),
            section: themeFields.themeSection_Coloring,
            group: themeFields.themeGroup_Coloring
        },

        //    mergeSeriesByStack  when Stacked_and_SBS
        //LL: themeFields.geometryMisc_mergeSeriesByStack => themeFields.coloring_separateColorsToSideBySideStacks
        //LL:  my flag  MergeSeriesByStack_New
        {
            id: themeFields.coloring_separateColorsToSideBySideStacks,
            hidden: isHiddenWhen_MergeSeriesByStack_Old,
            param: new BooleanField(
                this.glob,
                'Assign separate colors to same value in different SideBySide Stacks (when using combined Stacked + SideBySide grouping)', //LL: LEO's
                [],
                false
            ),
            section: themeFields.themeSection_Coloring,
            group: themeFields.themeGroup_Coloring
        },

        // ------------- themeSection_Styling   themeGroup_Styling ------- 'widget-chart-var-styling-chartCustomStyles'

        {
            id: 'chart-styling-chartCustomStyles-fictiv',
            param: new StringField(
                glob,
                'Define the sets of styling properties applied to Chart elements, can be chosen in Tab "Data" of Chart Configuration dialog in column "Custom Style":',
                [],
                '',
                {
                    hidden: true,
                    readOnly: true,
                    inline: true
                }
            ),
            section: themeFields.themeSection_Styling,
            group: themeFields.themeGroup_Styling
        },

        {
            id: themeFields.styling_chartCustomStyles,
            param: new ChartCustomStylesField(
                this.glob,
                'Styles',
                [
                    ChartValidators.chartParams.customStyles_shouldHaveNames,
                    ChartValidators.chartParams.customStyles_namesUnique,
                    ChartValidators.chartParams.customStyles_Opacity
                ],
                null
            ),
            isArray: true, //LL: but maybe not needed
            prohibitClearable: true,
            prohibitInheritedIcon: true,
            merger: appTheme.mergerForArrays,
            section: themeFields.themeSection_Styling,
            group: themeFields.themeGroup_Styling
        },

        //LL: ---------- Title ----

        {
            id: themeFields.title_ownTitle,
            hidden: isHidden_forD3,
            param: new StringField(glob, 'Own Title or empty to use Widget Title', [], '', {
                allowNull: true,
                changeOnBlurOnly: true,
                applyOnEnter: true
            }),
            section: themeFields.themeSection_Title
        },
        {
            id: themeFields.title_subTitle,
            hidden: isHidden_forD3,
            param: new StringField(glob, 'SubTitle (empty if not in use)', [], '', {
                allowNull: true,
                changeOnBlurOnly: true,
                applyOnEnter: true
            }),
            section: themeFields.themeSection_Title
        },
        {
            id: themeFields.title_color,
            hidden: isHidden_forD3,
            param: new ColorBoxField(this.glob, 'Font Color', [], '#636363', { hideTransparency: false }),
            section: themeFields.themeSection_Title,
            group: themeFields.themeGroup_Title_Font
        },
        //LL: 25.06.25
        {
            id: themeFields.title_font,
            hidden: isHidden_forD3,
            param: new FontBoxField(
                this.glob,
                'Font',
                [],
                function (theme) {
                    //LL: must depend on Widget's Font, nor Main
                    return {
                        face: theme['widget-font'],
                        size: theme['widget-font-size'],
                        weight: theme['widget-font-weight'],
                        color: Color(theme['on-primary']).hexString()
                    };
                },
                {
                    showColor: false
                }
            ),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_Title,
            group: themeFields.themeGroup_Title_Font,
            deps: ['widget-font', 'widget-font-size', 'widget-font-weight', 'on-primary']
        },
        //LL: 26.06.25
        {
            id: themeFields.title_subTitle_useOwnFont,
            hidden: isHidden_forD3,
            param: new BooleanField(this.glob, 'Use own Font for SubTitle', [], true),
            section: themeFields.themeSection_Title
        },
        //LL: 25.06.25
        {
            id: themeFields.title_subTitle_color,
            hidden: isHidden_title_subTitle_useOwnFont, // isHidden_forD3,
            param: new ColorBoxField(this.glob, 'SubTitle Font Color', [], '#636363', { hideTransparency: false }),
            section: themeFields.themeSection_Title,
            group: themeFields.themeGroup_Title_subTitle_Font
        },
        //LL: 26.06.25
        {
            id: themeFields.title_subTitle_font,
            hidden: isHidden_title_subTitle_useOwnFont, // isHidden_forD3,
            param: new FontBoxField(
                this.glob,
                'Font',
                [],
                function (theme) {
                    //LL: must depend on Widget's Font, nor Main
                    return {
                        face: theme['widget-font'],
                        size: theme['widget-font-size'],
                        weight: theme['widget-font-weight'],
                        color: Color(theme['on-primary']).hexString()
                    };
                },
                {
                    showColor: false
                }
            ),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_Title,
            group: themeFields.themeGroup_Title_subTitle_Font,
            deps: ['widget-font', 'widget-font-size', 'widget-font-weight', 'on-primary']
        },
        {
            id: themeFields.title_horizontalAlignment,
            hidden: isHidden_forD3,
            param: new SelectField(this.glob, 'Horizontal Alignment', [], 'center', {
                values: ['center', 'left', 'right'],
                display: ['center', 'left', 'right']
            }),
            section: themeFields.themeSection_Title,
            group: themeFields.themeGroup_Title_Position
        },
        {
            id: themeFields.title_verticalAlignment,
            hidden: isHidden_forD3,
            param: new SelectField(this.glob, 'Vertical Alignment', [], 'top', {
                values: ['top', 'bottom'],
                display: ['top', 'bottom']
            }),
            section: themeFields.themeSection_Title,
            group: themeFields.themeGroup_Title_Position
        },

        // ------------- themeSection_Geometry   themeGroup_GeometryMisc -------

        {
            id: themeFields.geometryMisc_showPointsInArea,
            param: new BooleanField(this.glob, 'Show Points for Areas', [], false),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_GeometryMisc
        },

        {
            id: themeFields.geometryMisc_showPointsInLines,
            param: new BooleanField(this.glob, 'Show Points for Lines', [], true),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_GeometryMisc
        },

        {
            id: themeFields.geometryMisc_setStacked,
            param: new BooleanField(this.glob, 'Use Stacked to combine values for Multiple Queries', [], false),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_GeometryMisc
        },

        {
            id: themeFields.geometryMisc_showEmptyBars,
            param: new BooleanField(
                this.glob,
                'Reserve space for Missing/Zero Bars for side-by-side values',
                [],
                true //LL: was old comment: set to true, seems DevExpress bug when Stacked with empty values
            ),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_GeometryMisc
        },

        {
            id: themeFields.geometryMisc_emptyValuesAsZero,
            param: new BooleanField(this.glob, 'Empty Values as Zero for continuous (line, area) charts', [], true),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_GeometryMisc
        },

        //    mergeSeriesByStack  when Stacked_and_SBS
        //LL: themeFields.geometryMisc_mergeSeriesByStack => themeFields.coloring_separateColorsToSideBySideStacks
        //LL:  my flag  MergeSeriesByStack_New
        {
            id: themeFields.geometryMisc_mergeSeriesByStack,
            hidden: isHiddenWhen_MergeSeriesByStack_New,
            param: new BooleanField(
                this.glob,
                'Merge Groups of Values from different Stacks for "Stacked+SideBySide" grouping',
                [],
                false
            ),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_GeometryMisc
        },

        {
            id: themeFields.geometryMisc_fullStacked,
            param: new BooleanField(this.glob, 'Show Stacked as FullStacked', [], false),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_GeometryMisc
        },

        {
            id: themeFields.geometryMisc_asPolarChart,
            param: new BooleanField(this.glob, 'Show as PolarChart', [], false),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_GeometryMisc
        },

        // ------------- themeSection_Geometry   themeGroup_BarOptions -------

        {
            id: themeFields.barOptions_minBarSize,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(
                this.glob,
                'Minimal Possible Bar Height (px)', //'Min Bar Height (px)',
                [validators.number.not_negative, validators.number.integer],
                0,
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_BarOptions
        },

        {
            id: themeFields.barOptions_barPadding,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(
                this.glob,
                'Bar Padding (%)',
                [
                    validators.number.not_negative,
                    validators.number.integer //,
                    //ChartValidators.chartParams.percent_Max   //LL: options instead
                ],
                10,
                {
                    min: 0,
                    max: 100,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_BarOptions
        },

        {
            id: themeFields.barOptions_barGroupPadding,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(
                this.glob,
                'Bar Group Padding (%)',
                [
                    validators.number.not_negative,
                    validators.number.integer
                    //ChartValidators.chartParams.percent_Max   //LL: options instead
                ],
                30,
                {
                    min: 0,
                    max: 100,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_BarOptions
        },

        // ------------- themeSection_Geometry   themeGroup_PieOptions -------

        {
            id: themeFields.pieOptions_diameter,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(
                this.glob,
                'Diameter (0<d<=1 or empty)',
                [validators.number.positive, validators.number.range(0, 1)],
                null,
                {
                    allowNull: true,
                    integer: false,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Geometry,
            group: themeFields.themeGroup_PieOptions
        },

        // ------------- themeSection_Legend   no groups -------

        {
            id: themeFields.legend_legendVisible,
            param: new BooleanField(this.glob, 'Visible', [], false),
            section: themeFields.themeSection_Legend
        },

        {
            id: themeFields.legend_itemSorting,
            param: new SelectField(this.glob, 'Item Sorting', [], 'ascending', {
                //LL: UpDown Sorting (Opposite Order)   for XY ?
                values: ['none', 'ascending', 'descending', 'oppositeOrder'],
                display: ['none', 'ascending', 'descending', 'opposite order']
            }),
            section: themeFields.themeSection_Legend
        },

        {
            id: themeFields.legend_includeSbsLabelIntoNames,
            param: new BooleanField(
                this.glob,
                'Include Side-By-Side Label into Names (when Stacked + Side-by-Side)',
                [],
                true
            ),
            section: themeFields.themeSection_Legend
        },

        {
            id: themeFields.legend_includeDataQueryIndexIntoNames,
            param: new BooleanField(
                this.glob,
                'Include Data Query Index into Names (when > 1 Queries, and Stacked or Side-by-Side)',
                [],
                true
            ),
            section: themeFields.themeSection_Legend
        },

        {
            id: themeFields.legend_includeAxisNameIntoNames,
            param: new BooleanField(this.glob, 'Include Axis Name into Names (for Auxiliary Value Axes)', [], true),
            section: themeFields.themeSection_Legend
        },

        //{
        //    id: themeFields.legend_text_notD3,
        //    param: new StringField(
        //        glob,
        //        'Except for areaMap and bubbleMap Charts:',
        //        [],
        //        "",
        //        {
        //            hidden: true,  // new
        //            readOnly: true,
        //            inline: true   // ok
        //        }
        //    ),
        //    section: themeFields.themeSection_Legend
        //},

        {
            id: themeFields.legend_legendPositionInsideOutside,
            hidden: isHidden_forD3, // (level, widgetParams) //LL: use it in ThemeField.tsx  getFields
            param: new SelectField(this.glob, 'Position', [], 'outside', {
                values: ['outside', 'inside'],
                display: ['outside', 'inside']
            }),
            section: themeFields.themeSection_Legend,
            group: themeFields.themeGroup_Legend_notD3
        },

        {
            id: themeFields.legend_legendPosition,
            hidden: isHidden_forD3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Orientation', [], 'vert', {
                values: ['vert', 'horiz'],
                display: ['vertical', 'horizontal'] //,
                //onChange: function (values, value) {  //LL: was in main
                //    let legendOrientation = value;
                //    if (legendOrientation === 'horiz') {
                //        values.legendPosition2 = 'bottom';
                //    }
                //    else {
                //        values.legendPosition2 = 'right';
                //    }
                //    this.legendOrientation_Cur = value;
                //    return values;
                //}
            }),
            section: themeFields.themeSection_Legend,
            group: themeFields.themeGroup_Legend_notD3
        },

        {
            id: themeFields.legend_legendAlignmentHoriz,
            hidden: isHidden_forD3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Alignment for Horizontal Orientation', [], 'bottom', {
                values: ['bottom', 'top'],
                display: ['bottom', 'top']
            }),
            section: themeFields.themeSection_Legend,
            group: themeFields.themeGroup_Legend_notD3
        },

        {
            id: themeFields.legend_legendAlignmentVert,
            hidden: isHidden_forD3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Alignment for Vertical Orientation', [], 'right', {
                values: ['left', 'right'],
                display: ['left', 'right']
            }),
            section: themeFields.themeSection_Legend,
            group: themeFields.themeGroup_Legend_notD3
        },

        {
            id: themeFields.legend_legendColumnCountHoriz,
            hidden: isHidden_forD3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(
                this.glob,
                'Column Count for Horizontal Orientation', // 'Column count Horizontal',
                [validators.number.positive, validators.number.integer],
                5,
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Legend,
            group: themeFields.themeGroup_Legend_notD3
        },

        {
            id: themeFields.legend_legendColumnCountVert,
            hidden: isHidden_forD3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(
                this.glob,
                'Column Count for Vertical Orientation', // 'Column count Vertical',
                [validators.number.positive, validators.number.integer],
                1,
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Legend,
            group: themeFields.themeGroup_Legend_notD3
        },

        //{
        //    id: themeFields.legend_text_D3,
        //    param: new StringField(
        //        glob,
        //        'for areaMap and bubbleMap Charts:',
        //        [],
        //        "",
        //        {
        //            hidden: true,  // new
        //            readOnly: true,
        //            inline: true   // ok
        //        }
        //    ),
        //    section: themeFields.themeSection_Legend
        //},

        {
            id: themeFields.legend_legendPosition_D3,
            hidden: isHidden_not_D3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Legend Position for AreaMap and BubbleMap Charts',
                [],
                chartConstants.d3_constants.d3_default_legendPosition, // 'right',
                {
                    values: ['left', 'right'],
                    display: ['left', 'right']
                }
            ),
            section: themeFields.themeSection_Legend,
            group: themeFields.themeGroup_Legend_D3
        },

        {
            id: themeFields.legend_color_bgColor,
            param: new ColorBoxField(
                this.glob,
                'Background Color',
                [],
                //  DevExpr default is undef     Set null or transparent ?
                //'transparent',  //null,
                function (theme) {
                    return theme['widget-bg'];
                },
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_Legend,
            deps: ['widget-bg']
        },

        {
            id: themeFields.legend_color_fontColor,
            param: new ColorBoxField(
                this.glob,
                'Text Color',
                [],
                //'#ff0000',
                function (theme) {
                    //return theme[ColorManager.themeFields_forDefaultColors.tooltip.themeFieldForDefault_foreColor];
                    //  DevExpr default is #767676
                    return theme['gray-base'];
                    //LL try: NO-NO return theme['text-color']; // in appTheme.template.css: {{render_context}}.widget {color: <%= theme['text-color'] %>;
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_Legend,
            deps: ['gray-base']
        },

        {
            id: themeFields.font_inLegend,
            param: new FontBoxField(
                this.glob,
                'Font',
                [],
                function (theme) {
                    //LL: must depend on Widget's Font, nor Main
                    return {
                        face: theme['widget-font'],
                        size: theme['widget-font-size'],
                        weight: theme['widget-font-weight'],
                        color: Color(theme['on-primary']).hexString()
                    };
                },
                {
                    showColor: false
                }
            ),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_Legend,
            deps: ['widget-font', 'widget-font-size', 'widget-font-weight', 'on-primary']
        },

        // ------------- themeSection_ZoomingAndScrolling   themeGroup_ScrollBar_old -------

        {
            id: themeFields.scrollBarOld_scrollOrZoom_show,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Show', [], false),
            section: themeFields.themeSection_ZoomingAndScrolling,
            group: themeFields.themeGroup_ScrollBar_old
        },

        {
            id: themeFields.scrollBarOld_scrollOrZoom_adjustScale,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Adjust Scale during Scroll (only for Continuous X axis)', [], false),
            section: themeFields.themeSection_ZoomingAndScrolling,
            group: themeFields.themeGroup_ScrollBar_old
        },

        {
            id: themeFields.scrollBarOld_scrollOrZoom_rangeSelector_position,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Position', [], 'bottom', {
                values: ['bottom', 'top'],
                display: ['bottom', 'top']
            }),
            section: themeFields.themeSection_ZoomingAndScrolling,
            group: themeFields.themeGroup_ScrollBar_old
        },

        {
            id: themeFields.scrollBarOld_scrollOrZoom_rangeSelector_chartType,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Chart Type', [], 'area', {
                //LL: error when Bar
                values: ['area', 'line', 'spline'],
                display: ['area', 'line', 'spline']
            }),
            section: themeFields.themeSection_ZoomingAndScrolling,
            group: themeFields.themeGroup_ScrollBar_old
        },

        // ------------- themeSection_ZoomingAndScrolling   themeGroup_ZoomingAndScrolling_new -------

        {
            id: themeFields.zoomingAndScrollingNew_zoom_Arguments,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Allow Zoom for Argument Axis', [], false),
            section: themeFields.themeSection_ZoomingAndScrolling,
            group: themeFields.themeGroup_ZoomingAndScrolling_new
        },

        {
            id: themeFields.zoomingAndScrollingNew_scroll_Arguments,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Allow Scroll for Argument Axis', [], false),
            section: themeFields.themeSection_ZoomingAndScrolling,
            group: themeFields.themeGroup_ZoomingAndScrolling_new
        },

        {
            id: themeFields.zoomingAndScrollingNew_zoom_Values,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Allow Zoom for Value Axis', [], false),
            section: themeFields.themeSection_ZoomingAndScrolling,
            group: themeFields.themeGroup_ZoomingAndScrolling_new
        },

        {
            id: themeFields.zoomingAndScrollingNew_scroll_Values,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Allow Scroll for Value Axis', [], false),
            section: themeFields.themeSection_ZoomingAndScrolling,
            group: themeFields.themeGroup_ZoomingAndScrolling_new
        },

        {
            id: themeFields.zoomingAndScrollingNew_scrollBar_show,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Show ScrollBar (for Arguments)', [], false),
            section: themeFields.themeSection_ZoomingAndScrolling,
            group: themeFields.themeGroup_ZoomingAndScrolling_new
        },

        //  scrollBar_position
        //LL: only top/bottom here, change to left/right if rotatedXY when applying
        //    position - Specifies the position of the scroll bar in the chart.   def = 'top'
        //        'bottom' | 'left' | 'right' | 'top'
        //        Depending on whether the chart is rotated or not, this option accepts different values.
        //        In a non-rotated chart, you can assign either 'top' or 'bottom' to this option.
        //        In a rotated chart, this option accepts either 'left' or 'right'
        {
            id: themeFields.zoomingAndScrollingNew_scrollBar_position,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'ScrollBar Position',
                [],
                'top', //  by DevExpr
                {
                    values: ['top', 'bottom'],
                    display: ['top', 'bottom']
                }
            ),
            section: themeFields.themeSection_ZoomingAndScrolling,
            group: themeFields.themeGroup_ZoomingAndScrolling_new
        },

        // ------------- themeSection_Crosshair   no groups -------

        {
            id: themeFields.crosshair_enabled,
            param: new BooleanField(this.glob, 'Crosshair Enabled', [], false),
            section: themeFields.themeSection_Crosshair
        },

        {
            id: themeFields.crosshair_visible_Vert,
            param: new BooleanField(
                this.glob,
                'Vertical Line Visible',
                [],
                true // DevExpr default is True
            ),
            section: themeFields.themeSection_Crosshair
        },
        {
            id: themeFields.crosshair_visible_Horiz,
            param: new BooleanField(
                this.glob,
                'Horizontal Line Visible',
                [],
                true // DevExpr default is True
            ),
            section: themeFields.themeSection_Crosshair
        },

        {
            id: themeFields.crosshair_line_color,
            param: new ColorBoxField(
                this.glob,
                'Line Color',
                [],
                ColorManager.themeFields_forDefaultColors.crosshair.defaultColors_static.lineColor, //'#f05b41', // DevExpr default
                //function (theme) {
                //    //return theme[ColorManager.themeFields_forDefaultColors.tooltip.themeFieldForDefault_backColor];
                //    return theme['surface-bg']; // == "Surface"
                //},
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_Crosshair
        },

        {
            id: themeFields.crosshair_line_width,
            param: new NumberField(
                this.glob,
                'Line Width',
                [validators.number.positive, validators.number.integer],
                1,
                {
                    min: 1,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Crosshair
        },

        {
            id: themeFields.crosshair_line_dashStyle,
            param: new SelectField(this.glob, 'Line Dash Style', [], 'solid', {
                values: _.map(CHART_CONSTANT_LINES.dashStyle, function (obj) {
                    return obj.value;
                }),
                display: _.map(CHART_CONSTANT_LINES.dashStyle, function (obj) {
                    return obj.display;
                })
            }),
            section: themeFields.themeSection_Crosshair
        },

        {
            id: themeFields.crosshair_labels_visible_Vert,
            param: new BooleanField(
                this.glob,
                'Labels for Vertical Line Visible',
                [],
                false // DevExpr default
            ),
            section: themeFields.themeSection_Crosshair,
            group: themeFields.themeGroup_crosshairLabels
        },
        {
            id: themeFields.crosshair_labels_visible_Horiz,
            param: new BooleanField(
                this.glob,
                'Labels for Horizontal Line Visible',
                [],
                false // DevExpr default
            ),
            section: themeFields.themeSection_Crosshair,
            group: themeFields.themeGroup_crosshairLabels
        },

        //LL: there are also Font params
        {
            id: themeFields.crosshair_labels_back_color,
            param: new ColorBoxField(
                this.glob,
                'Labels Back Color',
                [],
                ColorManager.themeFields_forDefaultColors.crosshair.defaultColors_static.backColor, //'#f05b41', // DevExpr default
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_Crosshair,
            group: themeFields.themeGroup_crosshairLabels
        },
        {
            id: themeFields.crosshair_labels_font_color,
            param: new ColorBoxField(
                this.glob,
                'Labels Font Color',
                [],
                ColorManager.themeFields_forDefaultColors.crosshair.defaultColors_static.foreColor, //'#ffffff', // DevExpr default
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_Crosshair,
            group: themeFields.themeGroup_crosshairLabels
        },

        // ------------- themeSection_Tooltips   no groups -------

        {
            id: themeFields.tooltips_enabled,
            param: new BooleanField(this.glob, 'Tooltips Enabled', [], true),
            section: themeFields.themeSection_Tooltips
        },

        {
            id: themeFields.tooltips_shared,
            param: new BooleanField(
                this.glob,
                'Show all values for the Argument in the tooltip', //  by Leo
                [],
                false
            ),
            section: themeFields.themeSection_Tooltips
        },

        {
            id: themeFields.tooltips_backcolor,
            param: new ColorBoxField(
                this.glob,
                'Back Color',
                [],
                function (theme) {
                    //return theme[ColorManager.themeFields_forDefaultColors.tooltip.themeFieldForDefault_backColor];
                    return theme['surface-bg']; // == "Surface"
                },
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_Tooltips,
            deps: ['surface-bg']
        },

        {
            id: themeFields.tooltips_fontColor,
            param: new ColorBoxField(
                this.glob,
                'Text Color',
                [],
                function (theme) {
                    //return theme[ColorManager.themeFields_forDefaultColors.tooltip.themeFieldForDefault_foreColor];
                    return theme['gray-base'];
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_Tooltips,
            deps: ['gray-base']
        },

        {
            id: themeFields.font_inTooltip,
            hidden: isHidden_forD3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new FontBoxField(
                this.glob,
                'Font (not used for areaMap and bubbleMap Charts)', // 'Font in Tooltips (not used for areaMap and bubbleMap Charts)',
                [],
                function (theme) {
                    //LL: must depend on Widget's Font, nor Main
                    return {
                        face: theme['widget-font'],
                        size: theme['widget-font-size'],
                        weight: theme['widget-font-weight'],
                        color: Color(theme['on-primary']).hexString()
                    };
                },
                {
                    showColor: false
                }
            ),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_Tooltips,
            deps: ['widget-font', 'widget-font-size', 'widget-font-weight', 'on-primary']
        },

        {
            id: themeFields.tooltips_showTotal,
            param: new BooleanField(
                this.glob,
                'Show Total if exists',
                [],
                themeFieldsDefaults.tooltips_showTotal //false
            ),
            section: themeFields.themeSection_Tooltips
        },

        {
            id: themeFields.tooltips_showPercent,
            param: new BooleanField(
                this.glob,
                'Show Percent if exists',
                [],
                themeFieldsDefaults.tooltips_showPercent //false
            ),
            section: themeFields.themeSection_Tooltips
        },

        // ------------- themeSection_PointLabels   outside groups -------

        //  outside groups:  No, default "show" is different for XY and Pie

        ////    labelXY_show, ...
        //{
        //    id: themeFields.pointLabels_label_show,
        //    param: new BooleanField(
        //        this.glob,
        //        'Show Point Labels',
        //        [],
        //        false
        //    ),
        //    section: themeFields.themeSection_PointLabels
        //},

        // ------------- themeSection_PointLabels   themeGroup_PointLabels_XY -------

        {
            id: themeFields.pointLabels_XY_show,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Show Point Labels', [], false),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_XY
        },

        {
            id: themeFields.pointLabels_XY_connectorVisible,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Connector Visible', [], false),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_XY
        },

        {
            id: themeFields.pointLabels_XY_position,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Label Position', [], 'outside', {
                values: ['inside', 'outside'],
                display: ['inside', 'outside']
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_XY
        },

        {
            id: themeFields.pointLabels_XY_alignment,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Label Alignment (not applied to rotated Charts)', [], 'center', {
                values: ['left', 'right', 'center'],
                display: ['left', 'right', 'center']
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_XY
        },

        {
            id: themeFields.pointLabels_XY_rotationAngle,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(
                this.glob,
                'Rotation Angle in degrees (-180 180)',
                [validators.number.range(-180, 180), validators.number.integer],
                0,
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_XY
        },

        {
            id: themeFields.pointLabels_XY_verticalOffset,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(this.glob, 'Vertical Offset', [validators.number.integer], 0, {
                applyOnEnter: true
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_XY
        },

        {
            id: themeFields.pointLabels_XY_horizontalOffset,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(this.glob, 'Horizontal Offset', [validators.number.integer], 0, {
                applyOnEnter: true
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_XY
        },

        {
            id: themeFields.pointLabels_XY_resolveLabelOverlapping,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Resolve Label Overlapping', [], 'none', {
                values: ['none', 'hide', 'stack'],
                display: ['none', 'hide', 'stack']
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_XY
        },

        // ------------- themeSection_PointLabels   themeGroup_PointLabels_Pie -------

        {
            id: themeFields.pointLabels_Pie_show,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Show Point Labels', [], true),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie
        },

        {
            id: themeFields.pointLabels_Pie_showPieLabelsThreshold,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(
                this.glob,
                'Max Label Count',
                [validators.number.not_negative, validators.number.integer],
                20,
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie
        },

        {
            id: themeFields.pointLabels_Pie_connectorVisible,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Connector Visible', [], true),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie
        },

        {
            id: themeFields.pointLabels_Pie_position,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Position', [], 'outside', {
                values: ['outside', 'inside', 'columns'],
                display: ['outside', 'inside', 'columns']
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie
        },

        {
            id: themeFields.pointLabels_Pie_rotationAngle,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(
                this.glob,
                'Rotation Angle (dg)',
                [validators.number.range(-180, 180), validators.number.integer],
                0,
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie
        },

        {
            id: themeFields.pointLabels_Pie_radialOffset,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(this.glob, 'Radial Offset', [validators.number.integer], 0, {
                applyOnEnter: true
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie
        },

        {
            id: themeFields.pointLabels_Pie_resolveLabelOverlapping,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Resolve Label Overlapping', [], 'none', {
                values: ['none', 'hide', 'shift'],
                display: ['none', 'hide', 'shift']
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie
        },

        {
            id: themeFields.pointLabels_Pie_useDefaultFontColor,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Use Automatic Text Color', [], true),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie_Color
        },

        {
            id: themeFields.pointLabels_Pie_fontColor,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new ColorBoxField(
                this.glob,
                'Text Color (when Automatic is Off)',
                [],
                //function (theme) {
                //    //  "widget-palette-white",  // #ffffff
                //    return theme[ColorManager.themeFields_forDefaultColors.pointLabels.themeFieldForDefault_foreColor_Pie];
                //},
                '#ffffff',
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie_Color
        },

        //==========================

        {
            id: themeFields.pointLabels_Pie_backgroundColor_default,
            hidden: isHidden_not_Pie,
            param: new BooleanField(
                this.glob,
                'Use Automatic Background Color (equal to Point Color)', // it is DevExpr default
                [],
                true
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie_Color
        },

        //{
        //    id: 'pointLabels_Pie_not-useDefaultBackgroundColor-fictiv',
        //    hidden: isHidden_not_Pie,
        //    param: new StringField(
        //        glob,
        //        'Otherwise use Color:',
        //        [],
        //        "",
        //        {
        //            hidden: true,
        //            readOnly: true,
        //            inline: true
        //        }
        //    ),
        //    section: themeFields.themeSection_PointLabels,
        //    group: themeFields.themeGroup_PointLabels_Pie_Color
        //},

        {
            id: themeFields.pointLabels_Pie_backgroundColor,
            hidden: isHidden_not_Pie,
            param: new ColorBoxField(
                this.glob,
                'Background Color (when Automatic is Off)',
                [],
                function (theme) {
                    // it is widget-palette-small-element-back-color
                    //return theme[ColorManager.themeFields_forDefaultColors.pointLabels.themeFieldForDefault_backColor];
                    return Color(theme['gray-base']).mix(Color(theme['body-bg']), 0.9).hexString();
                },
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie_Color,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.pointLabels_Pie_borderVisible,
            hidden: isHidden_not_Pie,
            param: new BooleanField(this.glob, 'Border Visible', [], false),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie_Color
        },

        {
            id: themeFields.pointLabels_Pie_borderColor,
            hidden: isHidden_not_Pie,
            param: new ColorBoxField(
                this.glob,
                'Border Color',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['body-bg']), 0.5).hexString();
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie_Color,
            deps: ['gray-base', 'body-bg']
        },

        //========================

        //    labelPie_addSeriesName used when Ys > 1
        {
            id: themeFields.pointLabels_Pie_addSeriesName,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Add Series Name into Label when Multi series', [], true),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Pie
        },

        // ------------- themeSection_PointLabels   themeGroup_PointLabels_D3 -------

        {
            id: themeFields.pointLabels_D3_show,
            hidden: isHidden_not_D3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Show Point Labels', [], true),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_D3
        },

        {
            id: themeFields.pointLabels_D3_labelInOneLine,
            hidden: isHidden_not_D3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(
                this.glob,
                'Label in Single Line', // 'In One Line'
                [],
                chartConstants.d3_constants.d3_default_labelInOneLine //true
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_D3
        },

        //    d3_labelHideRadius  bubbleMap
        //  'Hide Labels for Size:'  ' in ' + chartConstants.d3_constants.d3_bubbleCompact_Name + ':'
        {
            id: themeFields.pointLabels_D3_labelHideRadius,
            hidden: isHidden_not_D3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(
                this.glob,
                chartConstants.d3_constants.d3_bubbleCompact_Name + ': hide Labels for Radius(px) smaller than',
                [validators.number.integer],
                chartConstants.d3_constants.d3_default_labelHideRadius, // 25
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_D3
        },

        //  d3_labelHideWidth, d3_labelHideHeight  areaMap
        //  ' in ' + chartConstants.d3_constants.d3_treeMap_Name + ':'
        //  'Width(px)'  'Height(px)',
        {
            id: themeFields.pointLabels_D3_labelHideSize,
            hidden: isHidden_not_D3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SizeField(
                this.glob,
                chartConstants.d3_constants.d3_treeMap_Name + ': hide Labels for Size(px) smaller than',
                [],
                {
                    width: chartConstants.d3_constants.d3_default_labelHideWidth,
                    height: chartConstants.d3_constants.d3_default_labelHideHeight
                }, // 30,14
                { isInteger: true }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_D3
        },

        //    d3_labelPositionHoriz  areaMap
        {
            id: themeFields.pointLabels_D3_labelPositionHoriz,
            hidden: isHidden_not_D3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Label Horizontal Position (for areaMap)',
                [],
                chartConstants.d3_constants.d3_default_labelPositionHoriz, // 'left',
                {
                    values: ['left', 'center', 'right'],
                    display: ['left', 'center', 'right']
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_D3
        },

        //    d3_labelPositionVert  areaMap
        {
            id: themeFields.pointLabels_D3_labelPositionVert,
            hidden: isHidden_not_D3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Label Vertical Position (for areaMap)',
                [],
                chartConstants.d3_constants.d3_default_labelPositionVert, // 'top',
                {
                    values: ['top', 'middle', 'bottom'],
                    display: ['top', 'middle', 'bottom']
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_D3
        },

        {
            id: themeFields.pointLabels_D3_labelColor,
            hidden: isHidden_not_D3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new ColorBoxField(
                this.glob,
                'Text Color',
                [],
                //function (theme) {
                //    //  widget-palette-black
                //    return theme[ColorManager.themeFields_forDefaultColors.pointLabels.themeFieldForDefault_foreColor_D3];
                //},
                '#000000',
                {
                    hideTransparency: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_D3
        },

        // ------------- themeSection_PointLabels   themeGroup_PointLabels_Color -------
        //LL: only for XY  !!!

        //    labelXY_useDefaultColor
        {
            id: themeFields.pointLabels_color_useDefaultColor,
            hidden: isHidden_not_XY,
            param: new BooleanField(
                this.glob,
                'Use Point Label Color equal to Series Color', // it is DevExpr default
                [],
                true
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Color
        },

        //LL: this or in each "Text" and "Back" Colors below:
        {
            id: 'pointLabels_color_not-useDefaultColor-fictiv',
            hidden: isHidden_not_XY,
            param: new StringField(glob, 'Otherwise use Colors:', [], '', {
                hidden: true,
                readOnly: true,
                inline: true
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Color
        },

        {
            id: themeFields.pointLabels_color_fontColor,
            hidden: isHidden_not_XY,
            param: new ColorBoxField(
                this.glob,
                'Text Color',
                [],
                function (theme) {
                    //return theme[ColorManager.themeFields_forDefaultColors.pointLabels.themeFieldForDefault_foreColor];
                    return Color(theme['gray-base']).hexString();
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Color,
            deps: ['gray-base']
        },

        {
            id: themeFields.pointLabels_color_backgroundColor,
            hidden: isHidden_not_XY,
            param: new ColorBoxField(
                this.glob,
                'Background Color',
                [],
                function (theme) {
                    // it is widget-palette-small-element-back-color
                    //return theme[ColorManager.themeFields_forDefaultColors.pointLabels.themeFieldForDefault_backColor];
                    return Color(theme['gray-base']).mix(Color(theme['body-bg']), 0.9).hexString();
                },
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Color,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.pointLabels_color_borderVisible,
            hidden: isHidden_not_XY,
            param: new BooleanField(this.glob, 'Border Visible', [], false),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Color
        },

        {
            id: themeFields.pointLabels_color_borderColor,
            hidden: isHidden_not_XY,
            param: new ColorBoxField(
                this.glob,
                'Border Color',
                [],
                function (theme) {
                    //  widget-palette-small-element-border-color
                    //return theme[ColorManager.themeFields_forDefaultColors.pointLabels.themeFieldForDefault_borderColor];
                    return Color(theme['gray-base']).mix(Color(theme['body-bg']), 0.5).hexString();
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_Color,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.font_inPointLabels,
            param: new FontBoxField(
                this.glob,
                'Font', // 'Font in Point Labels',
                [],
                function (theme) {
                    //LL: must depend on Widget's Font, nor Main
                    return {
                        face: theme['widget-font'],
                        size: theme['widget-font-size'],
                        weight: theme['widget-font-weight'],
                        color: Color(theme['on-primary']).hexString()
                    };
                },
                {
                    showColor: false
                }
            ),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_PointLabels,
            deps: ['widget-font', 'widget-font-size', 'widget-font-weight', 'on-primary']
        },

        // ------------- themeSection_PointLabels   themeGroup_PointLabels_ShowInLabel -------

        {
            id: themeFields.pointLabels_showInLabel_standard,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectMultiField(
                this.glob,
                'Show in Label for standard Charts (bars, lines, areas, scatter)',
                [],
                ['value'],
                {
                    values: ['value', 'argument', 'group', 'stack', 'total', 'percent', 'diffPercent']
                    //getModifiedValues: ChartWidget.getModifiedValues_labelXY_textFormat_standard_multi
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_ShowInLabel
        },

        {
            id: themeFields.pointLabels_showInLabel_standard_addValueDataLabel,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(
                this.glob,
                'Extended Label Text Mode for standard Charts', // Expanded
                [],
                false
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_ShowInLabel
        },

        {
            id: themeFields.pointLabels_showInLabel_bubble,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectMultiField(this.glob, 'Show in Label for Bubble Charts', [], ['size'], {
                values: ['value', 'size', 'argument']
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_ShowInLabel
        },

        {
            id: themeFields.pointLabels_showInLabel_bubble_addValueDataLabel,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Extended Label Text Mode for Bubble Charts', [], false),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_ShowInLabel
        },

        {
            id: themeFields.pointLabels_showInLabel_range,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Show in Label for Range Charts (rangebar, rangearea)', [], '2 values', {
                values: ['2 values', '2 labels'],
                display: ['1 label with 2 values', '2 individual labels']
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_ShowInLabel
        },

        {
            id: themeFields.pointLabels_showInLabel_fiscal,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Show in Label for Fiscal Charts (candlestick, stock)', [], '4 values', {
                values: ['4 values'],
                display: ['4 values']
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_ShowInLabel
        },

        {
            id: themeFields.pointLabels_showInLabel_pie,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectMultiField(this.glob, 'Show in Label for Pie/Doughnut Charts', [], ['argument', 'value'], {
                values: ['value', 'value_percent', 'argument']
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_ShowInLabel
        },

        {
            id: themeFields.pointLabels_showInLabel_pie_addValueDataLabel,
            hidden: isHidden_not_Pie, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Extended Label Text Mode for Pie/Doughnut Charts', [], false),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_ShowInLabel
        },

        {
            id: themeFields.pointLabels_showInLabel_d3,
            hidden: isHidden_not_D3, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectMultiField(
                this.glob,
                'Show in Label for AreaMap and BubbleMap Charts',
                [],
                chartConstants.d3_constants.d3_default_label_ShowInLabel, //['argument'],
                {
                    values: ['value', 'argument']
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_ShowInLabel
        },

        // ------------- themeSection_PointLabels   themeGroup_PointLabels_onlyOneLabelPerStack -------

        {
            id: themeFields.pointLabels_onlyOneLabelPerStack_enable,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Enable', [], false),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_onlyOneLabelPerStack
        },

        {
            id: themeFields.pointLabels_onlyOneLabelPerStack_useDefaultColor,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(this.glob, 'Use Color of Upper Point in Stack', [], true),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_onlyOneLabelPerStack
        },

        //LL: this or in each "Text" and "Back" Colors below:
        {
            id: 'pointLabels_color_not-onlyOneLabelPerStack-useDefaultColor-fictiv',
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new StringField(glob, 'Otherwise use Colors:', [], '', {
                hidden: true,
                readOnly: true,
                inline: true
            }),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_onlyOneLabelPerStack
        },

        {
            id: themeFields.pointLabels_onlyOneLabelPerStack_fontColor,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL:  use it in ThemeField.tsx
            param: new ColorBoxField(
                this.glob,
                'Text Color',
                [],
                function (theme) {
                    //return theme[ColorManager.themeFields_forDefaultColors.pointLabels.themeFieldForDefault_foreColor];
                    return Color(theme['gray-base']).hexString();
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_onlyOneLabelPerStack,
            deps: ['gray-base']
        },

        {
            id: themeFields.pointLabels_onlyOneLabelPerStack_backgroundColor,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new ColorBoxField(
                this.glob,
                'Background Color',
                [],
                function (theme) {
                    // it is widget-palette-small-element-back-color
                    //return theme[ColorManager.themeFields_forDefaultColors.pointLabels.themeFieldForDefault_backColor];
                    return Color(theme['gray-base']).mix(Color(theme['body-bg']), 0.9).hexString();
                },
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_onlyOneLabelPerStack,
            deps: ['gray-base', 'body-bg']
        },

        // ------------- themeSection_PointLabels   themeGroup_PointLabels_SubTitles -------
        //LL: only for XY and Bars !!!

        {
            id: themeFields.pointLabels_subTitles_fontColor,
            hidden: isHidden_not_XY,
            param: new ColorBoxField(
                this.glob,
                'Text Color',
                [],
                function (theme) {
                    return Color(theme['gray-base']).hexString();
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_SubTitles,
            deps: ['gray-base']
        },

        {
            id: themeFields.pointLabels_subTitles_backgroundColor,
            hidden: isHidden_not_XY,
            param: new ColorBoxField(
                this.glob,
                'Background Color',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['body-bg']), 0.9).hexString();
                },
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_SubTitles,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.pointLabels_subTitles_borderVisible,
            hidden: isHidden_not_XY,
            param: new BooleanField(this.glob, 'Border Visible', [], false),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_SubTitles
        },

        {
            id: themeFields.pointLabels_subTitles_borderColor,
            hidden: isHidden_not_XY,
            param: new ColorBoxField(
                this.glob,
                'Border Color',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['body-bg']), 0.5).hexString();
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_SubTitles,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.pointLabels_subTitles_font,
            hidden: isHidden_not_XY,
            param: new FontBoxField(
                this.glob,
                'Font',
                [],
                function (theme) {
                    //LL: must depend on Widget's Font, nor Main
                    return {
                        face: theme['widget-font'],
                        size: theme['widget-font-size'],
                        weight: theme['widget-font-weight'],
                        color: Color(theme['on-primary']).hexString()
                    };
                },
                {
                    showColor: false
                }
            ),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_SubTitles,
            deps: ['widget-font', 'widget-font-size', 'widget-font-weight', 'on-primary']
        },

        {
            id: themeFields.pointLabels_subTitles_paddingLeftRight,
            hidden: isHidden_not_XY,
            param: new NumberField(
                this.glob,
                'Padding Left/Right (empty space around text) in pixels',
                [validators.number.integer, validators.number.not_negative, validators.number.range(0, 20)],
                2,
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_SubTitles
        },
        {
            id: themeFields.pointLabels_subTitles_paddingTopBottom,
            hidden: isHidden_not_XY,
            param: new NumberField(
                this.glob,
                'Padding Top/Bottom (empty space around text) in pixels',
                [validators.number.integer, validators.number.not_negative, validators.number.range(0, 20)],
                2,
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_SubTitles
        },
        {
            id: themeFields.pointLabels_subTitles_width,
            hidden: isHidden_not_XY,
            param: new NumberField(
                this.glob,
                'Width in pixels (leave empty for Auto)',
                [validators.number.integer, validators.number.positive, validators.number.range(1, 50)],
                null, //0,
                {
                    allowNull: true,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_SubTitles
        },
        {
            id: themeFields.pointLabels_subTitles_height,
            //hidden: isHidden_not_XY,
            hidden: true, //LL: don't use height
            param: new NumberField(
                this.glob,
                'Height in pixels (leave empty for Auto)',
                [validators.number.integer, validators.number.positive, validators.number.range(1, 30)],
                null, //0,
                {
                    allowNull: true,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_SubTitles
        },

        {
            id: themeFields.pointLabels_subTitles_adjustTop, //LL: for offsetY
            hidden: isHidden_not_XY,
            param: new NumberField(
                this.glob,
                'Adjust Top (move down) of SubTitle Labels in pixels. 0 means the center of Label is on the Argument Axis',
                [validators.number.integer, validators.number.not_negative, validators.number.range(0, 50)],
                10,
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_SubTitles
        },

        {
            id: themeFields.pointLabels_subTitles_argumentAxisLabelsIndentation,
            hidden: isHidden_not_XY,
            param: new NumberField(
                this.glob,
                'Indentation of Argument Axis Labels (empty space for SubTitles) in pixels',
                [validators.number.integer, validators.number.not_negative, validators.number.range(0, 100)],
                20,
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_PointLabels,
            group: themeFields.themeGroup_PointLabels_SubTitles
        },

        // ------------- themeSection_Axis  no groups -------

        {
            id: themeFields.axis_ChartAxisField_X,
            hidden: isHidden_not_XY, // (levels, widgetParams, widgetType) //LL: use it in ThemeField.tsx
            param: new ChartAxisField_inThemes(
                this.glob,
                'Argument Axis',
                [ChartValidators.chartParams.axis_label_currency],
                {}, //null,
                {
                    //noTitle: true,  //LL: to save space at the top of field;  title:'' is not enough
                    name: 'Arguments',
                    kind: 'x',
                    themeFields_forDefaultColors: ColorManager.themeFields_forDefaultColors.axis_new,
                    themeFieldForAxisList: themeFields.axis_axisList, //LL: is not used until required, do not remove
                    isMultiValueAxis_Func: ChartPropsManager.isMultiValueAxis, // (values)
                    getModifiedValuesAndDisplay_Full_Func:
                        ChartPropsManager.getModifiedValuesAndDisplay_argumentAxis_AxisType_Full,
                    canAxisLabelPrecision_byLabelFormat_Func: ChartPropsManager.canAxisLabelPrecision_byLabelFormat,
                    getDataType_Func: ChartPropsManager.get_argumentAxis_DataType_withTimePart
                    //getIsAxisReduced_Func: ChartPropsManager.getIsAxisReduced,

                    //getFormatFrontArray_Numeric_Func: ChartPropsManager.getFormatFrontArray_Numeric,
                    //getFormatFrontArray_DateTime_Func: ChartPropsManager.getFormatFrontArray_DateTime,
                    //getFormatFrontArray_Date_Func: ChartPropsManager.getFormatFrontArray_Date,
                    //getFormatFrontArray_Time_Func: ChartPropsManager.getFormatFrontArray_Time,
                    //getFormatFrontArray_TimePart_Func: ChartPropsManager.getFormatFrontArray_TimePart, // (timePart)
                    //getFormatFrontArray_TimeIntervals_Int_Func: ChartPropsManager.getFormatFrontArray_TimeIntervals_Int,
                    //getFormatFrontArray_TimeIntervals_Real_Func: ChartPropsManager.getFormatFrontArray_TimeIntervals_Real,

                    //onChange: function (values, value) {
                    //    // - "Scatter" ChartType with discrete Argument axis
                    //    //    to show notification when configuration changed (Leo wants), not when Chart is rendered
                    //    ChartPropsManager.processScatterWithDiscreteArgumentAxis(values, null, value, theme);  // + theme
                    //    return values;
                    //}
                }
            ),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_Axis_Arguments
        },

        {
            id: themeFields.axis_ChartAxisField_Y,
            hidden: isHidden_not_XY, // (levels, widgetParams, widgetType) //LL: use it in ThemeField.tsx
            param: new ChartAxisField_inThemes(
                this.glob,
                'Value Axis',
                [ChartValidators.chartParams.axis_label_currency],
                {}, //null,
                {
                    //noTitle: true,  //LL: to save space at the top of field;  title:'' is not enough
                    name: 'Values',
                    kind: 'y',

                    themeFields_forDefaultColors: ColorManager.themeFields_forDefaultColors.axis_new,

                    themeFieldForAxisList: themeFields.axis_axisList, //LL: is not used until required, do not remove
                    isMultiValueAxis_Func: ChartPropsManager.isMultiValueAxis, // (values)
                    //getIsAxisReduced_Func: ChartPropsManager.getIsAxisReduced,

                    getDataType_Func: ChartPropsManager.get_valueAxis_DataType_withTimePart,
                    is_fullStackedOnAxis_Func: ChartPropsManager.is_fullStackedOnAxis, // (themeObj, values, axisName?)
                    //getFormatFrontArray_Numeric_Func: ChartPropsManager.getFormatFrontArray_Numeric,
                    //getFormatFrontArray_DateTime_Func: ChartPropsManager.getFormatFrontArray_DateTime,
                    //getFormatFrontArray_Date_Func: ChartPropsManager.getFormatFrontArray_Date,
                    //getFormatFrontArray_Time_Func: ChartPropsManager.getFormatFrontArray_Time,
                    //getFormatFrontArray_TimePart_Func: ChartPropsManager.getFormatFrontArray_TimePart, // (timePart)
                    //getFormatFrontArray_TimeIntervals_Int_Func: ChartPropsManager.getFormatFrontArray_TimeIntervals_Int,
                    //getFormatFrontArray_TimeIntervals_Real_Func: ChartPropsManager.getFormatFrontArray_TimeIntervals_Real,
                    canAxisLabelPrecision_byLabelFormat_Func: ChartPropsManager.canAxisLabelPrecision_byLabelFormat,
                    getModifiedValuesAndDisplay_Full_Func:
                        ChartPropsManager.getModifiedValuesAndDisplay_valueAxis_AxisType_Full,
                    hasAxis_Bubble_Func: ChartPropsManager.hasAxis_Bubble // (values, axisName?)

                    //LL: was not for Y
                    //onChange: function (values, value) {
                }
            ),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_Axis_Values
        },

        {
            id: themeFields.axis_ChartAxisField_Arr,
            hidden: isHidden_not_XY, // (levels, widgetParams, widgetType) //LL: use it in ThemeField.tsx
            prohibitClearable: true,
            prohibitInheritedIcon: true, //LL: don't show arrow-down icon
            param: new ChartAxisArrayField_inThemes(this.glob, 'Additional Value Axes', [], null, {
                //noTitle: true,  //LL: to save space at the top of field;  title:'' is not enough

                themeFields_forDefaultColors: ColorManager.themeFields_forDefaultColors.axis_new,
                themeFieldForAxisList: themeFields.axis_axisList //LL: is not used until required, do not remove

                //getIsAxisReduced_Func: ChartPropsManager.getIsAxisReduced,
                //isUsed_SecondaryValueAxis_Func: ChartPropsManager.isUsed_SecondaryValueAxis, // (values, axisName)
                //isAssignedSecondaryAxis_Func: ChartPropsManager.isAssignedSecondaryAxis, // NEW (values, axisName)
                //getDataType_Func: ChartPropsManager.get_secondaryAxis_DataType_withTimePart, //  (values, axisName)
                //is_fullStackedOnAxis_Func: ChartPropsManager.is_fullStackedOnAxis, // (themeObj, values, axisName?)
                //getFormatFrontArray_Numeric_Func: ChartPropsManager.getFormatFrontArray_Numeric,
                //getFormatFrontArray_DateTime_Func: ChartPropsManager.getFormatFrontArray_DateTime,
                //getFormatFrontArray_Date_Func: ChartPropsManager.getFormatFrontArray_Date,
                //getFormatFrontArray_Time_Func: ChartPropsManager.getFormatFrontArray_Time,
                //getFormatFrontArray_TimePart_Func: ChartPropsManager.getFormatFrontArray_TimePart, // (timePart)
                //getFormatFrontArray_TimeIntervals_Int_Func: ChartPropsManager.getFormatFrontArray_TimeIntervals_Int,
                //getFormatFrontArray_TimeIntervals_Real_Func: ChartPropsManager.getFormatFrontArray_TimeIntervals_Real,
                //canAxisLabelPrecision_byLabelFormat_Func: ChartPropsManager.canAxisLabelPrecision_byLabelFormat,
                //getModifiedValuesAndDisplay_Full_Func: ChartPropsManager.getModifiedValuesAndDisplay_secondaryAxis_AxisType_Full,
                //hasAxis_Bubble_Func: ChartPropsManager.hasAxis_Bubble, // (values, axisName?)

                //LL: remove Axis was used when in Params, not in Themes. Bad when on all Levels !?
                //LL: not built-in, my own  TRY
                // onChange: function (values, value, themeObj) {
                //     //console.log("ChartAxisArrayField_inThemes  onChange  NEW");
                //     //if (value.removeAxis != null) {
                //     //    let axisName = value.removeAxis;  // to rem this axis
                //     //
                //     //    //LL: is sense here ?   themeObj is a copy !  So check in actual Strips/ConstLines fields
                //     //    let Strips = themeObj[themeFields.axisStrips_ActualStrips].slice(0);
                //     //    let fnd = true;
                //     //    while (fnd) {
                //     //        fnd = false;
                //     //        for (let k = 0; k < Strips.length; k++) {
                //     //            if (Strips[k].type === axisName) {
                //     //                Strips.splice(k, 1);
                //     //                fnd = true;
                //     //                break;
                //     //            }
                //     //        }
                //     //    }
                //     //    themeObj[themeFields.axisStrips_ActualStrips] = Strips;
                //     //
                //     //    // ConstLines ?
                //     //}
                // }

                //onChange: function (values, value) {
                //    console.log("ChartAxisArrayField_inThemes  onChange");  //LL: not issued automatically as for props
                //    if (value.removeAxis != null) {
                //        let axisName = value.removeAxis;  // to rem this axis
                //
                //        let Strips = values['chartStrips'].slice(0);
                //        let fnd = true;
                //        while (fnd) {
                //            fnd = false;
                //            for (let k = 0; k < Strips.length; k++) {
                //                if (Strips[k].type === axisName) {
                //                    Strips.splice(k, 1);
                //                    fnd = true;
                //                    break;
                //                }
                //            }
                //        }
                //        values['chartStrips'] = Strips;
                //
                //        let ConstantLines = values['chartConstantLines'].slice(0);
                //        fnd = true;
                //        while (fnd) {
                //            fnd = false;
                //            for (let k = 0; k < ConstantLines.length; k++) {
                //                if (ConstantLines[k].type === axisName) {
                //                    ConstantLines.splice(k, 1);
                //                    fnd = true;
                //                    break;
                //                }
                //            }
                //        }
                //        values['chartConstantLines'] = ConstantLines;
                //    }
                //
                //    return values;
                //}
            }),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_Axis_ExtraValues
        },

        //LL: id: themeFields.axisStrips_ActualStrips  is below, with other Strips and after them
        //    And ConstLines, and Breaks

        //---------------------------------

        {
            id: themeFields.axis_rotateXY,
            hidden: isHidden_not_XY,
            param: new BooleanField(this.glob, 'Rotated XY', [], false),
            section: themeFields.themeSection_Axis
        },

        {
            id: themeFields.axis_horizontalAxis_displayMode,
            hidden: isHidden_not_XY,
            param: new SelectField(
                this.glob,
                'Axis Label Display Mode', // 'Horizontal Axis: Label Display Mode',
                [],
                'standard',
                {
                    values: ['standard', 'rotate', 'stagger'],
                    display: ['standard', 'rotate', 'stagger']
                }
            ),
            section: themeFields.themeSection_Axis,
            group: themeFields.themeGroup_HorizontalAxis
        },

        {
            id: themeFields.axis_horizontalAxis_overlappingBehavior,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Label Overlapping Behavior', // 'Horizontal Axis: Label Overlapping Behavior',
                [],
                'rotate',
                {
                    values: ['none', 'rotate', 'stagger', 'hide'],
                    display: ['none', 'rotate', 'stagger', 'hide']
                }
            ),
            section: themeFields.themeSection_Axis,
            group: themeFields.themeGroup_HorizontalAxis
        },

        {
            id: themeFields.axis_horizontalAxis_argumentAngle,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(
                this.glob,
                'Label Angle (dg)', // 'Horizontal Axis: Label Angle (dg)',
                [validators.number.range(-90, 90), validators.number.integer],
                30,
                {
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Axis,
            group: themeFields.themeGroup_HorizontalAxis
        },

        {
            id: themeFields.axis_synchronizeMultiAxes,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new BooleanField(
                this.glob,
                'Synchronize Ticks and Grid Lines on "Synch On" fields for Multi Value Axes', // text by Leo
                [],
                true
            ),
            section: themeFields.themeSection_Axis
        },

        {
            id: themeFields.axis_axisColor,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new ColorBoxField(
                this.glob,
                'Axis and Grid Color',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['body-bg']), 0.5).hexString();
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_Axis,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.axis_axisLabelColor,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new ColorBoxField(
                this.glob,
                'Axis Label Color',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['body-bg']), 0.5).hexString(); // = axis_axisColor
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_Axis,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.axis_seriesColorAux,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new ColorBoxField(this.glob, 'Series Color for Aux Axis', [], '#ff0080', { hideTransparency: true }),
            section: themeFields.themeSection_Axis
        },

        {
            id: themeFields.font_inAxisLabels,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new FontBoxField(
                this.glob,
                'Font', // 'Font in Axis Labels',
                [],
                function (theme) {
                    //LL: must depend on Widget's Font, nor Main
                    return {
                        face: theme['widget-font'],
                        size: theme['widget-font-size'],
                        weight: theme['widget-font-weight'],
                        italic: theme['widget-font-italic'],
                        color: Color(theme['on-primary']).hexString()
                    };
                },
                {
                    showColor: false
                }
            ),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_Axis,
            deps: ['widget-font', 'widget-font-size', 'widget-font-weight', 'on-primary']
        },

        // ------------- themeSection_AxisBreaks  no groups -------

        //  was inside ChartAxisField  getBreaksColor '#ababab';  //LL: DevExpress default
        {
            id: themeFields.axisBreaks_color,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new ColorBoxField(
                this.glob,
                'Color',
                [],
                //LL: must be same as axis
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['body-bg']), 0.5).hexString();
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_AxisBreaks,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.axisBreaks_ActualBreaks,
            hidden: isHidden_not_XY, //LL: // (levels, widgetParams, widgetType) //LL: use it in ThemeField.tsx
            param: new ChartBreaksField_inThemes(
                this.glob,
                'Breaks',
                [
                    ChartValidators.chartParams.axisBreaks_shouldHaveValues,
                    validatorsColorScales.chartParams.customStyles_shouldHaveNames, // new
                    validatorsColorScales.chartParams.customStyles_namesUnique // new
                ],
                null,
                {
                    //noTitle: true,  //LL: to save space at the top of field;  title:'' is not enough
                    //getChartAxisArray_Func: ChartPropsManager.getChartAxisArray, //  (values, themeObj) //  NEW
                    //onEvalAuxAxisNames: ChartPropsManager.evalAuxAxisNames,
                    //getAxisType_Func: ChartPropsManager.getAxisType, //  (values, axisName)
                    //getDataType_X_Func: ChartPropsManager.get_argumentAxis_DataType_withTimePart,
                    //getDataType_Y_Func: ChartPropsManager.get_valueAxis_DataType_withTimePart
                }
            ),
            isArray: true, //LL: but maybe not needed
            prohibitClearable: true,
            prohibitInheritedIcon: true,
            merger: appTheme.mergerForArrays,
            section: themeFields.themeSection_AxisBreaks,
            group: themeFields.themeGroup_AxisBreaks
        },

        // ------------- themeSection_AxisStrips  no groups -------

        {
            id: themeFields.axisStrips_color,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new ColorBoxField(
                this.glob,
                'Color',
                [],
                function (theme) {
                    let color3 = theme['gray-base'];
                    return Color(theme['body-bg']).mix(Color(color3), 0.2).hexString();
                },
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_AxisStrips,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.axisStrips_fontColor,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new ColorBoxField(
                this.glob,
                'Text Color',
                [],
                function (theme) {
                    let color3 = theme['body-bg'];
                    return Color(theme['gray-base']).mix(Color(color3), 0.2).hexString();
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_AxisStrips,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.font_inStrips,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new FontBoxField(
                this.glob,
                'Font', // 'Font in Strips',
                [],
                function (theme) {
                    //LL: must depend on Widget's Font, nor Main
                    return {
                        face: theme['widget-font'],
                        size: theme['widget-font-size'],
                        weight: theme['widget-font-weight'],
                        color: Color(theme['on-primary']).hexString()
                    };
                },
                {
                    showColor: false
                }
            ),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_AxisStrips,
            deps: ['widget-font', 'widget-font-size', 'widget-font-weight', 'on-primary']
        },

        {
            id: themeFields.axisStrips_labelAlignmentVert_X,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Label Vertical Alignment for "Arguments" axis',
                [],
                'top', // 'top' for Arguments,    'center' for Values
                {
                    values: CHART_STRIPS.labelVerticalAlignment,
                    display: CHART_STRIPS.labelVerticalAlignment
                }
            ),
            section: themeFields.themeSection_AxisStrips
        },

        {
            id: themeFields.axisStrips_labelAlignmentHoriz_X,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Label Horizontal Alignment for "Arguments" axis',
                [],
                'center', // 'center' for Arguments,    'left' for Values
                {
                    values: CHART_CONSTANT_LINES.labelHorizontalAlignment,
                    display: CHART_CONSTANT_LINES.labelHorizontalAlignment
                }
            ),
            section: themeFields.themeSection_AxisStrips
        },

        {
            id: themeFields.axisStrips_labelAlignmentVert_Y,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Label Vertical Alignment for "Values" axis',
                [],
                'center', // 'top' for Arguments,    'center' for Values
                {
                    values: CHART_STRIPS.labelVerticalAlignment,
                    display: CHART_STRIPS.labelVerticalAlignment
                }
            ),
            section: themeFields.themeSection_AxisStrips
        },

        {
            id: themeFields.axisStrips_labelAlignmentHoriz_Y,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Label Horizontal Alignment for "Values" axis',
                [],
                'left', // 'center' for Arguments,    'left' for Values
                {
                    values: CHART_CONSTANT_LINES.labelHorizontalAlignment,
                    display: CHART_CONSTANT_LINES.labelHorizontalAlignment
                }
            ),
            section: themeFields.themeSection_AxisStrips
        },

        {
            id: themeFields.axisStrips_ActualStrips,
            hidden: isHidden_not_XY, //LL: // (levels, widgetParams, widgetType) //LL: use it in ThemeField.tsx
            param: new ChartStripsField_inThemes(
                this.glob,
                'Strips',
                [
                    ChartValidators.chartParams.axisStrips_shouldHaveValues,
                    validatorsColorScales.chartParams.customStyles_shouldHaveNames, // new
                    validatorsColorScales.chartParams.customStyles_namesUnique // new
                ],
                null,
                {
                    //noTitle: true,  //LL: to save space at the top of field;  title:'' is not enough
                    themeFields_forDefaultColors: ColorManager.themeFields_forDefaultColors.strip_constLine_new,

                    themeFields_forLabelAlignment: {
                        labelAlignmentVert_X: themeFields.axisStrips_labelAlignmentVert_X,
                        labelAlignmentHoriz_X: themeFields.axisStrips_labelAlignmentHoriz_X,
                        labelAlignmentVert_Y: themeFields.axisStrips_labelAlignmentVert_Y,
                        labelAlignmentHoriz_Y: themeFields.axisStrips_labelAlignmentHoriz_Y
                    },

                    //getChartAxisArray_Func: ChartPropsManager.getChartAxisArray,
                    onEvalAuxAxisNames: ChartPropsManager.evalAuxAxisNames,
                    //getAxisType_Func: ChartPropsManager.getAxisType,
                    //getDataType_X_Func: ChartPropsManager.get_argumentAxis_DataType_withTimePart,
                    //getDataType_Y_Func: ChartPropsManager.get_valueAxis_DataType_withTimePart,
                    //getDataType_Aux_Func: ChartPropsManager.get_secondaryAxis_DataType_withTimePart,
                    //prohibitAsPercent_SecondaryValueAxis_Func: ChartPropsManager.prohibitAsPercent_SecondaryValueAxis,

                    prohibitAsPercent_byAxisType_byAxisObjX_Func:
                        ChartPropsManager.prohibitAsPercent_byAxisType_byAxisObjX,
                    prohibitAsPercent_byAxisType_byAxisObjY_Func:
                        ChartPropsManager.prohibitAsPercent_byAxisType_byAxisObjY,

                    prohibitAsPercent_byAttrQuery_X_multi_Func: ChartPropsManager.prohibitAsPercent_byAttrQuery_X_multi,
                    prohibitAsPercent_byAttrQuery_Y_multi_Func: ChartPropsManager.prohibitAsPercent_byAttrQuery_Y_multi
                }
            ),
            isArray: true, //LL: but maybe not needed
            prohibitClearable: true,
            prohibitInheritedIcon: true,
            merger: appTheme.mergerForArrays,
            section: themeFields.themeSection_AxisStrips,
            group: themeFields.themeGroup_AxisStrips
        },

        // ------------- themeSection_AxisConstantLines  no groups -------

        {
            id: themeFields.axisConstantLines_color,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new ColorBoxField(
                this.glob,
                'Color',
                [],
                function (theme) {
                    let color3 = theme['body-bg'];
                    return Color(theme['gray-base']).mix(Color(color3), 0.2).hexString();
                },
                { hideTransparency: false }
            ),
            section: themeFields.themeSection_AxisConstantLines,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.axisConstantLines_fontColor,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new ColorBoxField(
                this.glob,
                'Text Color',
                [],
                function (theme) {
                    let color3 = theme['body-bg'];
                    return Color(theme['gray-base']).mix(Color(color3), 0.2).hexString();
                },
                { hideTransparency: true }
            ),
            section: themeFields.themeSection_AxisConstantLines,
            deps: ['gray-base', 'body-bg']
        },

        {
            id: themeFields.font_inConstLines,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new FontBoxField(
                this.glob,
                'Font',
                [],
                function (theme) {
                    //LL: must depend on Widget's Font, nor Main
                    return {
                        face: theme['widget-font'],
                        size: theme['widget-font-size'],
                        weight: theme['widget-font-weight'],
                        color: Color(theme['on-primary']).hexString()
                    };
                },
                {
                    showColor: false
                }
            ),
            isObject: true,
            merger: appTheme.mergerForObjects,
            section: themeFields.themeSection_AxisConstantLines,
            deps: ['widget-font', 'widget-font-size', 'widget-font-weight', 'on-primary']
        },

        //LL: differ fields for X and Y:

        {
            id: themeFields.axisConstantLines_labelAlignmentVert_X,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Label Vertical Alignment for "Arguments" axis',
                [],
                'top', // 'top' for Arguments,    'center' for Values
                {
                    values: CHART_CONSTANT_LINES.labelVerticalAlignment,
                    display: CHART_CONSTANT_LINES.labelVerticalAlignment
                }
            ),
            section: themeFields.themeSection_AxisConstantLines
        },

        {
            id: themeFields.axisConstantLines_labelAlignmentHoriz_X,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Label Horizontal Alignment for "Arguments" axis',
                [],
                'center', // 'center' for Arguments,    'left' for Values
                {
                    values: CHART_CONSTANT_LINES.labelHorizontalAlignment,
                    display: CHART_CONSTANT_LINES.labelHorizontalAlignment
                }
            ),
            section: themeFields.themeSection_AxisConstantLines
        },

        {
            id: themeFields.axisConstantLines_labelAlignmentVert_Y,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Label Vertical Alignment for "Values" axis',
                [],
                'center', // 'top' for Arguments,    'center' for Values
                {
                    values: CHART_CONSTANT_LINES.labelVerticalAlignment,
                    display: CHART_CONSTANT_LINES.labelVerticalAlignment
                }
            ),
            section: themeFields.themeSection_AxisConstantLines
        },

        {
            id: themeFields.axisConstantLines_labelAlignmentHoriz_Y,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(
                this.glob,
                'Label Horizontal Alignment for "Values" axis',
                [],
                'left', // 'center' for Arguments,    'left' for Values
                {
                    values: CHART_CONSTANT_LINES.labelHorizontalAlignment,
                    display: CHART_CONSTANT_LINES.labelHorizontalAlignment
                }
            ),
            section: themeFields.themeSection_AxisConstantLines
        },

        {
            id: themeFields.axisConstantLines_labelPosition,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Label Position', [], 'inside', {
                values: ['inside', 'outside'],
                display: ['inside', 'outside']
            }),
            section: themeFields.themeSection_AxisConstantLines
        },

        {
            id: themeFields.axisConstantLines_dashStyle,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new SelectField(this.glob, 'Dash Style', [], 'longDash', {
                values: _.map(CHART_CONSTANT_LINES.dashStyle, function (obj) {
                    return obj.value;
                }),
                display: _.map(CHART_CONSTANT_LINES.dashStyle, function (obj) {
                    return obj.display;
                })
            }),
            section: themeFields.themeSection_AxisConstantLines
        },

        {
            id: themeFields.axisConstantLines_width,
            hidden: isHidden_not_XY, // (level, widgetParams) //LL: use it in ThemeField.tsx
            param: new NumberField(this.glob, 'Width', [validators.number.positive, validators.number.integer], 1, {
                min: 1,
                applyOnEnter: true
            }),
            section: themeFields.themeSection_AxisConstantLines
        },

        {
            id: themeFields.axisConstantLines_ActualConstantLines,
            hidden: isHidden_not_XY, //LL: // (levels, widgetParams, widgetType) //LL: use it in ThemeField.tsx
            param: new ChartConstantLinesField_inThemes(
                this.glob,
                'Constant Lines',
                [
                    ChartValidators.chartParams.axisConstantLines_shouldHaveValues,
                    validatorsColorScales.chartParams.customStyles_shouldHaveNames, // new
                    validatorsColorScales.chartParams.customStyles_namesUnique // new
                ],
                null,
                {
                    //noTitle: true,  //LL: to save space at the top of field;  title:'' is not enough
                    themeFields_forDefaultColors: ColorManager.themeFields_forDefaultColors.strip_constLine_new,

                    themeFields_forLabelAlignment: {
                        labelAlignmentVert_X: themeFields.axisConstantLines_labelAlignmentVert_X,
                        labelAlignmentHoriz_X: themeFields.axisConstantLines_labelAlignmentHoriz_X,
                        labelAlignmentVert_Y: themeFields.axisConstantLines_labelAlignmentVert_Y,
                        labelAlignmentHoriz_Y: themeFields.axisConstantLines_labelAlignmentHoriz_Y
                    },

                    themeField_constantLinesLabelPositionDefault: themeFields.axisConstantLines_labelPosition,
                    themeField_constantLinesDashStyleDefault: themeFields.axisConstantLines_dashStyle,
                    themeField_constantLinesWidthDefault: themeFields.axisConstantLines_width,

                    getChartAxisArray_Func: ChartPropsManager.getChartAxisArray,
                    onEvalAuxAxisNames: ChartPropsManager.evalAuxAxisNames

                    //getAxisType_Func: ChartPropsManager.getAxisType,
                    //getDataType_X_Func: ChartPropsManager.get_argumentAxis_DataType_withTimePart,
                    //getDataType_Y_Func: ChartPropsManager.get_valueAxis_DataType_withTimePart,
                    //getDataType_Aux_Func: ChartPropsManager.get_secondaryAxis_DataType_withTimePart,
                    //prohibitAsPercent_SecondaryValueAxis_Func: ChartPropsManager.prohibitAsPercent_SecondaryValueAxis,
                    //prohibitAsPercent_byAxisType_byAxisObjX_Func: ChartPropsManager.prohibitAsPercent_byAxisType_byAxisObjX,
                    //prohibitAsPercent_byAxisType_byAxisObjY_Func: ChartPropsManager.prohibitAsPercent_byAxisType_byAxisObjY,
                    //prohibitAsPercent_byAttrQuery_X_multi_Func: ChartPropsManager.prohibitAsPercent_byAttrQuery_X_multi,
                    //prohibitAsPercent_byAttrQuery_Y_multi_Func: ChartPropsManager.prohibitAsPercent_byAttrQuery_Y_multi
                }
            ),
            isArray: true, //LL: but maybe not needed
            prohibitClearable: true,
            prohibitInheritedIcon: true,
            merger: appTheme.mergerForArrays,
            section: themeFields.themeSection_AxisConstantLines,
            group: themeFields.themeGroup_AxisConstantLines
        },

        // ------------- animation -------------------

        {
            id: themeFields.animation_enabled,
            param: new BooleanField(
                this.glob,
                'Enabled',
                [],
                themeFieldsDefaults.animation_enabled //true
            ),
            section: themeFields.themeSection_Animation
        },

        {
            id: themeFields.animation_duration,
            param: new NumberField(
                this.glob,
                'Duration (msec)',
                [validators.number.shouldBe, validators.number.positive, validators.number.integer],
                themeFieldsDefaults.animation_duration, // 500 is DevExpr default
                {
                    min: 1,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Animation
        },

        {
            id: themeFields.animation_maxPointCount,
            param: new NumberField(
                this.glob,
                'Max Point Count Supported',
                [validators.number.shouldBe, validators.number.positive, validators.number.integer],
                themeFieldsDefaults.animation_maxPointCount, // 300 is DevExpr default
                {
                    min: 1,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Animation
        },

        // ------------- AdaptiveLayout -------------------
        {
            id: themeFields.adaptiveLayout_size,
            param: new SizeField(
                this.glob,
                "Widget's size(px) small enough for the layout to begin adapting",
                [],
                {},
                { isInteger: true }
            ),
            section: themeFields.themeSection_AdaptiveLayout
        },
        {
            id: themeFields.adaptiveLayout_keepLabelsXY,
            param: new BooleanField(
                this.glob,
                //'For XY-charts keep Point Labels when the layout is adapting',
                //LL: Leo's suggestion with opposite meaning,
                //    but he also wants the default to be "hide", so default = true remains
                'For XY-charts: hide Point labels when widget becomes smaller than specified size',
                [],
                true //LL: true is default by DevExpress for keep Point Labels, //LL: so opposite now
            ),
            section: themeFields.themeSection_AdaptiveLayout
        },
        //LL: for Pie always false (by default of DevExpr)

        // ------------- Warnings -------------------

        {
            id: themeFields.warning_emptyData_show,
            param: new BooleanField(this.glob, 'Show "NO DATA" warning', [], true),
            section: themeFields.themeSection_Warnings
        },
        {
            id: themeFields.warning_emptyData_text,
            param: new StringField(
                this.glob,
                '"NO DATA" warning text',
                [validators.string.notAllBlanks],
                themeFieldsDefaults.warning_emptyData_text, //"NO DATA AVAILABLE"
                {
                    allowNull: false,
                    changeOnBlurOnly: true,
                    applyOnEnter: true
                }
            ),
            section: themeFields.themeSection_Warnings
        },

        {
            id: themeFields.DevExpress_messages_processing_method,
            param: new SelectField(this.glob, 'Method of Handling DevExpress messages', [], 'program', {
                values: ['native', 'program'], // builtin (embedded) ?
                display: ['DevExpress native method (message in console)', 'Program handling'] // processing
            }),
            section: themeFields.themeSection_Warnings,
            group: themeFields.themeGroup_DevExpress_messages
        },
        {
            id: themeFields.DevExpress_messages_warnings_console,
            //hidden: isHidden_DevExpress_messages_processing_method, // (level, widgetParams)
            param: new BooleanField(this.glob, 'Show DevExpress Warnings in Console', [], false),
            section: themeFields.themeSection_Warnings,
            group: themeFields.themeGroup_DevExpress_messages
        },
        {
            id: themeFields.DevExpress_messages_warnings_screen,
            //hidden: isHidden_DevExpress_messages_processing_method, // (level, widgetParams)
            param: new BooleanField(this.glob, 'Show DevExpress Warnings by Screen Notifications', [], false),
            section: themeFields.themeSection_Warnings,
            group: themeFields.themeGroup_DevExpress_messages
        },
        {
            id: themeFields.DevExpress_messages_errors_console,
            //hidden: isHidden_DevExpress_messages_processing_method, // (level, widgetParams)
            param: new BooleanField(this.glob, 'Show DevExpress Errors in Console', [], true),
            section: themeFields.themeSection_Warnings,
            group: themeFields.themeGroup_DevExpress_messages
        },
        {
            id: themeFields.DevExpress_messages_errors_screen,
            //hidden: isHidden_DevExpress_messages_processing_method, // (level, widgetParams)
            param: new BooleanField(this.glob, 'Show DevExpress Errors by Screen Notifications', [], true),
            section: themeFields.themeSection_Warnings,
            group: themeFields.themeGroup_DevExpress_messages
        }
    ]);

    appTheme.registerPreRender(function (input) {
        var vars = {};

        return _.extend(input, vars);
    });

    _init.push(glob);
}
